import { createStyles, makeStyles } from '@material-ui/core';
import Colors from '../../../../constants/Colors';
import { neutral, orange } from '../../../../shared/styles/colors';

export const orderDetailDisclaimer = makeStyles(() =>
  createStyles({
    container: {
      backgroundColor: orange[10],
      gridArea: 'disclaimer',
      borderLeft: `3px solid ${orange[60]}`,
    },
    content: {
      color: neutral.D18,
    },
    itemContainer: {
      padding: 0,
      paddingLeft: '1rem',
      listStyle: 'disc',
    },
    primaryText: {
      color: neutral[100],
      fontFamily: 'PP Object Sans',
      fontSize: '0.875rem',
      fontWeight: 500,
    },
    secondaryText: {
      color: neutral[80],
      fontFamily: 'PP Object Sans',
      fontSize: '0.75rem',
      fontWeight: 500,
      padding: 0,
      display: 'list-item',
    },
    tertiaryText: {
      fontSize: '0.75rem',
      fontWeight: 400,
    },
    quaternaryText: {
      color: orange[60],
      fontFamily: 'PP Object Sans',
      fontSize: '0.625rem',
      fontWeight: 400,
    },
    underline: {
      textDecoration: 'underline',
    },
    price: {
      fontSize: '1rem',
      fontWeight: 'bold',
    },
    warningIcon: {
      color: Colors.WARNING_FONT_COLOR,
    },
    btnSecondary: {
      minWidth: '9.125rem',
      color: Colors.SECONDARY_COLOR_DARK,
    },
    collapseIcon: (props?: StyleProps) => ({
      transform: `rotate(${props?.isContentCollapsed ? 180 : 0}deg)`,
      transition: '.25s ease-in-out',
      cursor: 'pointer',
      position: 'absolute',
      right: 16,
      top: 16,
    }),
  }),
);

type StyleProps = {
  isContentCollapsed?: boolean;
};
